import Vue from 'vue'
import Router from 'vue-router'

import api from '@/api'
import store from '@/store'

import Header from '@/views/Header'
import Login from '@/views/Login'

const ResetPassword = () => import(/* webpackChunkName: "reset_password" */'@/views/ResetPassword')

const Avvisi = () => import(/* webpackChunkName: "avvisi" */'@/views/Avvisi')
const Report = () => import(/* webpackChunkName: "report" */'@/views/Reports')
const Maps = () => import(/* webpackChunkName: "maps" */'@/views/PrenotazioniMap')
const PrenotazioniCalendar = () => import(/* webpackChunkName: "prenotazioni_calendar" */'@/views/PrenotazioniCalendar')
const PrenotazioniAdvanced = () => import(/* webpackChunkName: "prenotazioni_advanced" */'@/views/PrenotazioniAdvanced')
const Agricoltori = () => import(/* webpackChunkName: "agricoltori" */'@/views/Agricoltori')
const Convenzioni = () => import(/* webpackChunkName: "convenzioni" */'@/views/Convenzioni')
const Magazzino = () => import(/* webpackChunkName: "magazzino" */'@/views/Magazzino')
const UnitaMobili = () => import(/* webpackChunkName: "unita_mobili" */'@/views/UnitaMobili')
const Tecnici = () => import(/* webpackChunkName: "tecnici" */'@/views/Tecnici')
const Statistiche = () => import(/* webpackChunkName: "statistiche" */'@/views/Statistiche')
const Settings = () => import(/* webpackChunkName: "settings" */'@/views/Settings')
const Info = () => import(/* webpackChunkName: "not_available" */'@/views/Info')
const ScadenzaAttestati = () => import(/* webpackChunkName: "not_available" */'@/views/ScadenzaAttestati')
const NotFound = () => import(/* webpackChunkName: "not_available" */'@/views/NotFound')
const ExportReport = () => import(/* webpackChunkName: "aziende" */'@/views/ExportReport')

Vue.use(Router)

const _router = new Router({
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            component: Login
        },
        {
            path: '/primo_accesso',
            component: Settings
        },
        {
            path: '/reset_password',
            component: ResetPassword
        },
        {
            path: '/empty',
            component: Header,
            children: [
                {
                    path: '/avvisi',
                    component: Avvisi
                },
                {
                    path: '/report',
                    component: Report
                },
                {
                    path: '/export-report',
                    component: ExportReport
                },
                {
                    path: '/prenotazioni-calendar',
                    component: PrenotazioniCalendar
                },
                {
                    path: '/prenotazioni-advanced',
                    component: PrenotazioniAdvanced
                },
                {
                    path: '/prenotazioni-map',
                    component: Maps
                },
                {
                    path: '/agricoltori',
                    component: Agricoltori
                },
                {
                    path: '/convenzioni',
                    component: Convenzioni
                },
                {
                    path: '/magazzino',
                    component: Magazzino
                },
                {
                    path: '/unita-mobili',
                    component: UnitaMobili
                },
                {
                    path: '/tecnici',
                    component: Tecnici
                },
                {
                    path: '/statistiche',
                    component: Statistiche
                },
                {
                    path: '/info',
                    component: Info
                },
                {
                    path: '/impostazioni',
                    component: Settings
                },
                {
                    path: '/scadenza-attestati',
                    component: ScadenzaAttestati
                },
                {
                    path: '/*',
                    component: NotFound
                }
            ]
        }
    ]
})

//  Redirecting e logout se il token scade
api.instance.setResponseInterceptor(null, async (e) => {
    if (e.response && (e.response.status === 401 || e.response.status === 408)) {
        await store.dispatch('logout')
        _router.push('/')
        store.commit('SET_IS_TOKEN_EXPIRED', true)
    }
    throw e
})

//  Redirecting automatico
_router.beforeEach((to, from, next) => {
    if (store.getters.isLoggedIn && to.path === '/') {
        //  Se è loggato ma prova a tornare al login, torna alla sezione avvisi
        next('/avvisi')
    } else if (!store.getters.isLoggedIn && to.path !== '/' && to.path !== '/reset_password') {
        //  Se l'utente non è loggato viene effettuato il redirect alla pagina di login
        next('/')
    } else if (store.getters.isFirstAccess && to.path !== '/primo_accesso') {
        //  Se è il primo accesso, deve compilare i dati dell'azienda
        next('/primo_accesso')
    } else {
        //  Altrimenti continua alla pagina richiesta
        next()
    }
})

export default _router
